"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0m8-3.594c-1.22 0-2.232.976-2.232 2.208a.7.7 0 1 0 1.4 0A.82.82 0 0 1 10 7.806a.82.82 0 0 1 .832.809c0 .139-.04.226-.097.302a1.4 1.4 0 0 1-.348.296c-.43.285-1.088.801-1.088 1.791v.188a.7.7 0 1 0 1.4 0v-.188c0-.146.04-.237.101-.317.072-.096.187-.191.36-.307.42-.278 1.072-.788 1.072-1.765 0-1.231-1.01-2.21-2.232-2.21M9.3 13.2a.69.69 0 0 1 .695-.7.7.7 0 1 1-.695.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--inner-shape-color, transparent)",
  fillRule: "evenodd",
  d: "M7.768 8.614c0-1.232 1.011-2.208 2.232-2.208s2.232.978 2.232 2.21c0 .976-.651 1.486-1.071 1.765-.174.115-.289.21-.361.306a.49.49 0 0 0-.1.318v.188a.7.7 0 1 1-1.4 0v-.188c0-.99.657-1.506 1.087-1.791a1.4 1.4 0 0 0 .348-.297.46.46 0 0 0 .097-.302.82.82 0 0 0-.832-.809.82.82 0 0 0-.832.808.7.7 0 1 1-1.4 0",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--inner-shape-color, transparent)",
  d: "M9.995 12.5c-.387 0-.7.313-.695.7a.7.7 0 1 0 .695-.7"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HelpFillNavIcon20.js.map